













































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import OnsiteInfoStep from './OnsiteInfoStep'
import PaperworkRequirementsStep from './PaperworkRequirementsStep'
import ShippingInfoStep from './ShippingInfoStep'
import CompleteAdvanceStep from './CompleteAdvanceStep'
import RequestButton from '@/components/RequestButton'

settings = 
  resources:
    advance: 
      resourceName: "advance"
      slug: "offers/:offerId/advance/edit"
    paperwork_requirements:
      resourceName: "paperwork_requirement"
      slug: "advances/:advanceId/paperwork_requirements"
  vue:
    name: 'AdvanceWizard'
    props: ['advanceId', 'offerId']
    mixins: [WizardService.wizard()]
    components: { 
      OnsiteInfoStep, PaperworkRequirementsStep, ShippingInfoStep, RequestButton, CompleteAdvanceStep
    }
    computed: 
      # wizardIsLoaded: -> @resourceIsLoaded('prime.advance')
      isLastStep: -> @activeStep.idx + 1 is @steps.length
      progressBarStyle: -> { width: (((@activeStep.idx + 1) / @steps.length) * 100)  + '%' }
    methods:
      navigateForward: -> @saveStep( { navToStepAfterSave: @stepForIndex(@activeStep.idx + 1) })
      onResourceTriggerCompleted: -> @activeStepVm.onResourceTriggerCompleted?()
      onSave: (item) -> @activeStepVm.onSave?()
      onSaveFail: (resourceKey, item, options) ->

export default VueOptions.vue settings
